import { differenceInDays } from "date-fns";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl79ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      acceptedFinancialReport: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      usageFromDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      usageToDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .min(
          new Date("2019-01-31"),
          t("Η ημερομηνία χρήσης έως δεν μπορεί να είναι πριν την 31/01/2019"),
        ),
      nextUsageFromDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      nextUsageToDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      totalActive: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      businessCircle: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^(-)?[0-9]+(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      employees: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      assets: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      reserves: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      requirements: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      prepayments: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      equityTotal: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      obligationsTotal: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      resultsNoTax: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      internationalAccounting: yup.string().nullable(),
      singleFile: yup.string().nullable(),
      category: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocShortEconomicData: yup.string().nullable(),
      fudocAnnualEkthesi: yup
        .string()
        .nullable()
        .when(["internationalAccounting"], {
          is: (internationalAccounting: string) => {
            return !!internationalAccounting;
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocIsologismos: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) => {
            return !!category && !internationalAccounting && !singleFile;
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocKatastasiApotelesmaton: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) => {
            return !!category && !internationalAccounting && !singleFile;
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocKatastasiMetabolon: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) => {
            return (
              !internationalAccounting &&
              !singleFile &&
              ["medium", "big"].includes(category)
            );
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocKatastasiXrimatoroon: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) =>
            !internationalAccounting &&
            !singleFile &&
            ["big"].includes(category),
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocProsartima: yup
        .string()
        .nullable()
        .when(
          ["internationalAccounting", "singleFile"],
          ([internationalAccounting, singleFile], schema) => {
            if (!!internationalAccounting || !!singleFile) {
              return schema.notRequired();
            } else {
              return schema.required(t("Το πεδίο είναι υποχρεωτικό"));
            }
          },
        ),
      fudocOikonomikesKatastasis: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile"], {
          is: (internationalAccounting: string, singleFile: string) =>
            !internationalAccounting && !!singleFile,
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocEkthesi: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) =>
            !internationalAccounting &&
            ((!!singleFile && category !== "very small") ||
              (!singleFile && ["small", "medium", "big"].includes(category))),
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocEkthesiElegkton: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "category"], {
          is: (internationalAccounting: string, category: string) =>
            !internationalAccounting && ["medium", "big"].includes(category),
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocWeb: yup.string().nullable(),
      webDate: yup.date().nullable(),
      webURL: yup
        .string()
        .url(t("Το πεδίο πρέπει να είναι έγκυρος σύνδεσμος url")),
      paperDate: yup
        .date()
        .nullable()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      paperName: yup.string(),
      fudocPaper: yup.string().nullable(),
      auditCompanies: yup.array().default([]),
      auditPersons: yup.array().default([]),
      auditNewPersons: yup.array().default([]),
    })
    .test(
      "usage dates validation",
      t("Η ημερομηνία έναρξης πρέπει να είναι πριν την ημερομηνία λήξης"),
      (value) => {
        const { usageFromDate, usageToDate } = value;
        if (!usageFromDate || !usageToDate) return true;
        return usageFromDate < usageToDate;
      },
    )
    .test(
      "balance dates must me max year apart",
      t(
        "Ελέγξτε τις ημερομηνίες χρήσης. Η ημερομηνία έναρξης χρήσης πρέπει να απέχει το πολύ ένα χρόνο από την ημερομηνία λήξης.",
      ),
      (value) => {
        const { usageFromDate, usageToDate } = value;
        if (!usageFromDate || !usageToDate) return false;
        return (
          0 <= differenceInDays(usageToDate, usageFromDate) &&
          differenceInDays(usageToDate, usageFromDate) <= 365
        );
      },
    )
    .test(
      "usage to date must be before next usage dates",
      t(
        "Η ημερομηνία λήξης χρήσης πρέπει να είναι πριν την ημερομηνία έναρξης επόμενης χρήσης",
      ),
      (value) => {
        const { usageToDate, nextUsageFromDate } = value;
        if (!usageToDate || !nextUsageFromDate) return true;
        return usageToDate < nextUsageFromDate;
      },
    )
    .test(
      "next usage dates validation",
      t(
        "Η ημερομηνία έναρξης επόμενης χρήσης πρέπει να είναι πριν την ημερομηνία λήξης",
      ),
      (value) => {
        const { nextUsageFromDate, nextUsageToDate } = value;
        if (!nextUsageFromDate || !nextUsageToDate) return true;
        return nextUsageFromDate < nextUsageToDate;
      },
    )
    .test(
      "has filled all of website",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      (value) => {
        if (value?.fudocWeb || value?.webDate || value?.webURL) {
          return !!value?.fudocWeb && !!value?.webDate && !!value?.webURL;
        } else {
          return true;
        }
      },
    )
    .test(
      "has filled all of paper",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      (value) => {
        if (value?.fudocPaper || value?.paperDate || value?.paperName) {
          return (
            !!value?.fudocPaper && !!value?.paperDate && !!value?.paperName
          );
        } else {
          return true;
        }
      },
    )
    .test(
      "You have not entered auditors",
      t("Δεν έχετε δηλώσει κάποια ελεγκτική εταιρεία ή ελεγκτή."),
      (value) => {
        return (
          (value?.auditCompanies?.length || 0) > 0 ||
          (value?.auditPersons?.length || 0) > 0 ||
          (value?.auditNewPersons?.length || 0) > 0
        );
      },
    )
    .test(
      "You have not filled all auditor fields",
      t("Υπάρχει μη συμπληρωμένο υποχρεωτικό πεδίο στους ελεγκτές"),
      (value) => {
        const auditPersons = value.auditPersons;
        const auditNewPersons = value.auditNewPersons;

        if (auditPersons.length > 0) {
          for (let person of auditPersons) {
            if (
              !person.auditorType ||
              !person.elteNumber ||
              !person.firstName ||
              !person.lastName ||
              !person.fathersName
            ) {
              return false;
            }
          }
        }
        if (auditNewPersons.length > 0) {
          for (let person of auditNewPersons) {
            if (
              !person.firstName ||
              !person.lastName ||
              !person.fathersName ||
              !person.elteNumber ||
              !person.auditorType
            ) {
              return false;
            }
          }
        }

        return true;
      },
    );
};
